import { render, staticRenderFns } from "./ProviderAddOriginModal.vue?vue&type=template&id=4a51d80b"
import script from "./ProviderAddOriginModal.vue?vue&type=script&lang=js"
export * from "./ProviderAddOriginModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports